import React from "react"
import { Box, Typography, Button } from "@material-ui/core"
import styles from "./styles"
import { withStyles } from "@material-ui/core/styles"
import { useHistory } from "react-router-dom"
import AdminHeader from "../../components/AdminHeader"

const NoOrganizationPage = ({ classes }) => {
  let history = useHistory()
  const openCreateOrganization = () => {
    history.push("/signup")
  }
  const openJoinOrganization = () => {
    history.push("/app/add-org")
  }
  return (
    <Box>
      <AdminHeader />
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        className={classes.noOrganizationPageContainer}
      >
        <Typography variant="h2" className={classes.title}>
          You are not part of any organization.
        </Typography>
        <Typography variant="h4" className={classes.subtitle}>
          Please create or join one.
        </Typography>
        <Box>
          <Button
            variant="contained"
            color="primary"
            onClick={openJoinOrganization}
            className={classes.joinButton}
          >
            Join Organizaton
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={openCreateOrganization}
          >
            Create Organizaton
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export default withStyles(styles)(NoOrganizationPage)



// WEBPACK FOOTER //
// ./src/pages/NoOrganizationPage/index.jsx